import { render, staticRenderFns } from "./GoodsFieldSearch.vue?vue&type=template&id=2b44ebf4&scoped=true"
import script from "./GoodsFieldSearch.vue?vue&type=script&lang=js"
export * from "./GoodsFieldSearch.vue?vue&type=script&lang=js"
import style0 from "./GoodsFieldSearch.vue?vue&type=style&index=0&id=2b44ebf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b44ebf4",
  null
  
)

export default component.exports